import React from "react";
import {IconButton} from "@mui/material";
import {DeveloperBoard} from "@mui/icons-material";
import {observer} from "mobx-react-lite";
import {useStores} from '../../../stores';

export const DevopsMenuButton = observer(() => {
    const {authStore, rootAppStore} = useStores();

    if (!authStore.isMithraStaffGroup) {
        return <></>
    }

    return <IconButton
        edge="end"
        size="medium"
        aria-haspopup="true"
        color="inherit"
        onClick={() => rootAppStore.setIsDevopsMenuOpen(true)}>
        <DeveloperBoard/>
    </IconButton>
})
